<template>
	<div class="pl4 fs3" @click.stop="$emit('node:select', node)">
		<div
			class="cu2 bb1 bc7 pt3 pb3 lh125"
			:class="node.isSelected ? 'c2 fw7' : 'c1'"
		>
			{{ node.title }}
		</div>

		<template v-if="hasChildren">
			<aeg-steps-node
				v-for="(item, i) in node.children"
				:key="i"
				:node="item"
				v-on="$listeners"
			/>
		</template>
	</div>
</template>

<script>
export default {
	name: "AegStepsNode",
	props: { node: { type: Object } },
	computed: {
		hasChildren() {
			return this.node.children && this.node.children.length
		}
	}
}
</script>
